import React from 'react';
import { Link } from 'react-router-dom';

const safeGet = (key: string) => {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const HomePageDescriptionSection = ({ image, title, description }) => {
  const isB2B = Boolean(safeGet('token_b2b'));

  const staticUrl = isB2B
    ? '/b2b/produit/CIRTNTUN0059108-174'
    : '/produit/CIRTNTUN0059108-174';

  return (
    <div className="container space-2 position-relative">
      <div className="content-space-2 content-space-lg-3">
        <div className="row bg-light justify-content-lg-between align-items-md-center">
          <div className="col-md-8 order-md-2 mb-10 mb-md-0">
            <Link to={staticUrl} className="position-relative">
              <img
                className="rounded shadow-serious card-transition"
                height={300}
                width="100%"
                src={`https://www.keplertravel.com/${image}`}
                style={{ objectFit: 'cover' }}
                alt="Image Description"
              />
            </Link>
          </div>

          <div className="col-md-4 col-lg-4 order-md-1">
            <h2>{title}</h2>
            <blockquote className="blockquote blockquote-lg h3">{description}</blockquote>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageDescriptionSection;
